export class ServiceRecord {
  serviceDate?: Date;
  mileage?: number;
  monthInterval?: number;
  mileageInterval?: number;
  serviceType: string;

  rowIndex: number; // Index of the form control row - used for updating
}
